var _g, _g2, _g3, _g4, _g5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverlayDeskLeft1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 999,
    height: 1067,
    viewBox: "0 0 999 1067",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.366 141.314C121.243 136.442 136.944 121.691 142.072 101.464C149.553 71.9573 131.7 41.9698 102.188 34.4875C81.9646 29.36 61.5144 36.1355 48.2372 50.4112C43.3657 31.5341 28.6141 15.8335 8.39059 10.7061C-21.1209 3.22371 -51.1055 21.0823 -58.5865 50.5887C-63.715 70.8162 -56.9392 91.2661 -42.663 104.543C-61.5394 109.41 -77.2401 124.161 -82.3685 144.389C-89.8496 173.895 -71.9959 203.882 -42.4844 211.365C-22.2609 216.492 -1.8107 209.717 11.4653 195.445C16.3379 214.318 31.0896 230.019 51.3131 235.146C80.8246 242.629 110.809 224.77 118.29 195.264C123.419 175.036 116.643 154.586 102.366 141.314ZM24.4564 144.207C21.8188 133.994 16.2915 124.712 8.56361 117.531C18.7807 114.895 28.0626 109.368 35.2473 101.646C37.8849 111.858 43.4122 121.14 51.1389 128.326C40.923 130.957 31.6411 136.485 24.4564 144.207Z",
    fill: "#AECC1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.294 30.1255C135.215 38.2188 154.526 70.6545 146.434 102.57C141.537 121.885 127.726 136.576 110.521 143.38C122.407 157.556 127.55 177.054 122.652 196.369C114.56 228.285 82.128 247.601 50.2073 239.508C30.8945 234.612 16.2028 220.8 9.39826 203.598C-4.78019 215.48 -24.2777 220.623 -43.5905 215.727C-75.5111 207.634 -94.8223 175.198 -86.7305 143.283C-81.8333 123.967 -68.0228 109.275 -50.8186 102.474C-62.7029 88.2949 -67.8457 68.7983 -62.9486 49.4829C-54.8568 17.5676 -22.4243 -1.74906 9.49641 6.34404C28.8089 11.2405 43.501 25.0514 50.305 42.256C64.4842 30.3715 83.9818 25.2291 103.294 30.1255ZM33.1797 109.8C28.2574 113.926 22.6958 117.236 16.7221 119.598C20.8493 124.519 24.162 130.079 26.5242 136.051C31.446 131.926 37.0071 128.616 42.9802 126.256C38.8536 121.333 35.542 115.772 33.1797 109.8Z",
    stroke: "white",
    strokeWidth: 9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M664.301 882.595C665.754 880.855 667.846 878.845 670.959 878.362C673.859 877.912 676.414 879.022 678.081 879.82L678.081 879.821C683.291 882.316 689.348 887.09 693.462 890.094L694.258 890.67L694.258 890.67C712.586 903.792 729.454 917.257 747.788 929.512C750.945 931.621 754.336 933.625 757.963 935.857C761.499 938.032 765.182 940.381 768.496 942.979C770.63 944.652 773.819 947.206 775.815 950.48C776.872 952.214 777.722 954.341 777.827 956.806C777.915 958.852 777.475 960.856 776.565 962.77L776.495 963.832L772.487 967.427L772.115 967.666L727.54 996.306L727.457 996.36L727.373 996.411C718.937 1001.41 710.655 1006.93 702.125 1012.5C693.652 1018.02 684.978 1023.56 676.01 1028.4L676.009 1028.4C674.391 1029.28 670.919 1031.5 666.974 1031.89L664.204 1032.16L661.012 1028.6L660.704 1028.03C651.311 1010.76 644.268 992.464 642.228 972.366C639.387 944.365 644.62 918.19 657.89 893.371L657.889 893.371C658.561 892.114 659.616 890.066 660.673 888.176C661.701 886.338 662.996 884.159 664.301 882.596L664.301 882.595Z",
    fill: "#2E518E",
    stroke: "white",
    strokeWidth: 11
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M930.936 538.607L933.834 540.975C935.182 543.037 936.471 544.661 936.886 547.162C938.115 554.71 929.958 566.103 925.742 572.032C925.224 572.749 924.556 573.795 924.191 574.602L919.858 579.875C919.421 580.363 919.052 580.928 918.596 581.411C907.042 593.83 892.355 600.221 875.49 594.949C854.072 588.263 843.726 565.926 849.894 545.093C852.871 535.039 862.535 521.623 869.01 513.193C873.689 507.12 879.728 500.483 887.972 504.996C896.204 509.51 896.923 517.998 892.753 525.556C888.094 533.985 881.011 541.776 876.831 550.419C872.905 558.521 877.178 570.017 887.156 570.459C897.089 570.899 905.411 554.616 910.897 547.694C915.585 541.771 922.726 533.386 930.936 538.608L930.936 538.607Z",
    fill: "#F9B634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.893 596.857C852.333 589.814 841.529 566.303 847.977 544.525C849.546 539.226 852.828 533.168 856.452 527.462C859.64 522.442 863.159 517.592 866.168 513.62L867.424 511.974L867.425 511.972C869.76 508.942 872.644 505.476 876.134 503.405C877.913 502.35 879.903 501.622 882.098 501.522C884.304 501.421 886.588 501.958 888.933 503.242L888.933 503.243C893.535 505.766 896.172 509.503 896.978 513.763C897.773 517.959 896.755 522.444 894.504 526.522L894.503 526.524C892.108 530.856 889.095 535.017 886.247 539.059C883.368 543.146 880.641 547.133 878.631 551.289L878.631 551.291C876.943 554.774 877.008 559.044 878.594 562.471C880.156 565.845 883.116 568.278 887.245 568.46C889.147 568.545 891.102 567.838 893.143 566.419C895.19 564.996 897.198 562.943 899.148 560.568C901.092 558.201 902.915 555.594 904.62 553.104C906.299 550.652 907.902 548.253 909.329 546.452L910.238 545.314C912.448 542.579 915.263 539.379 918.514 537.289C920.399 536.077 922.525 535.174 924.848 534.997C926.366 534.882 927.906 535.083 929.449 535.646L929.583 534.919L932.201 537.058L935.099 539.426L935.339 539.621L935.509 539.881C936.741 541.767 938.358 543.814 938.859 546.834L938.86 546.84C939.59 551.327 937.545 556.588 935.121 561.143C932.638 565.809 929.469 570.242 927.372 573.191L927.368 573.197L927.363 573.203C926.878 573.874 926.299 574.795 926.014 575.425L925.905 575.667L925.737 575.871L921.403 581.146L921.376 581.178L921.347 581.21C921.187 581.389 921.034 581.587 920.814 581.871C920.612 582.131 920.352 582.464 920.05 582.784L920.049 582.784C908.137 595.582 892.694 602.422 874.893 596.857Z",
    stroke: "white",
    strokeWidth: 4
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-16.626 845.983C-9.32205 829.418 8.12156 819.219 26.1299 821.21C46.3761 823.45 61.9138 840.049 63.1729 860.088C70.1787 864.223 77.7705 867.399 85.6094 870.121L92.4111 872.03C101.416 862.033 115.055 856.817 128.505 858.554C157.976 862.361 174.134 894.688 159.558 920.585C150.078 937.426 129.788 945.444 111.372 940.002L111.28 939.976L111.19 939.943L106.897 938.371L106.579 938.253L106.295 938.069C105.86 937.787 105.367 937.529 104.745 937.222C104.168 936.937 103.418 936.579 102.708 936.177C89.8557 928.902 81.8951 914.93 81.7139 900.323C81.1302 900.033 80.5705 899.762 80.4014 899.681C71.5915 895.49 61.993 892.539 52.3496 890.823C52.1915 891.001 52.0344 891.181 51.8818 891.355C51.7807 891.47 51.6781 891.585 51.5869 891.687C51.5044 891.779 51.3954 891.9 51.2891 892.006L51.2881 892.007C41.3063 902.011 26.9992 906.49 13.0459 903.509C12.4005 903.371 11.7267 903.183 11.25 903.059C10.7195 902.921 10.3122 902.828 9.94043 902.78L9.60938 902.737L9.2959 902.622L5.25586 901.142L4.90723 901.014L4.60059 900.806C4.33752 900.627 4.01265 900.454 3.5459 900.23C3.14016 900.035 2.50213 899.744 1.93457 899.437V899.438C-13.6443 891.015 -22.3426 873.492 -19.4482 855.958L-19.4395 855.9L-19.4268 855.841L-18.4316 851.016L-18.3721 850.73L-18.2598 850.46C-18.014 849.875 -17.8036 849.238 -17.542 848.453C-17.2958 847.713 -17.001 846.833 -16.626 845.983Z",
    fill: "#2E518E",
    stroke: "#FAFAFA",
    strokeWidth: 6
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M697.374 87.9828C704.678 71.4177 722.122 61.2188 740.13 63.2104C760.376 65.4495 775.914 82.0487 777.173 102.088C784.179 106.223 791.77 109.399 799.609 112.121L806.411 114.03C815.416 104.033 829.055 98.817 842.505 100.554C871.976 104.361 888.134 136.688 873.558 162.585C864.078 179.426 843.788 187.444 825.372 182.002L825.28 181.976L825.19 181.943L820.897 180.371L820.579 180.253L820.295 180.069C819.86 179.787 819.367 179.529 818.745 179.222C818.168 178.937 817.418 178.579 816.708 178.177C803.856 170.902 795.895 156.93 795.714 142.323C795.13 142.033 794.571 141.762 794.401 141.681C785.592 137.49 775.993 134.539 766.35 132.823C766.191 133.001 766.034 133.181 765.882 133.355C765.781 133.47 765.678 133.585 765.587 133.687C765.504 133.779 765.395 133.9 765.289 134.006L765.288 134.007C755.306 144.011 740.999 148.49 727.046 145.509C726.401 145.371 725.727 145.183 725.25 145.059C724.72 144.921 724.312 144.828 723.94 144.78L723.609 144.737L723.296 144.622L719.256 143.142L718.907 143.014L718.601 142.806C718.338 142.627 718.013 142.454 717.546 142.23C717.14 142.035 716.502 141.744 715.935 141.437V141.438C700.356 133.015 691.657 115.492 694.552 97.9584L694.561 97.8998L694.573 97.8412L695.568 93.016L695.628 92.7299L695.74 92.4604C695.986 91.875 696.196 91.2385 696.458 90.4526C696.704 89.713 696.999 88.8333 697.374 87.9828Z",
    fill: "#FF7506",
    stroke: "#FAFAFA",
    strokeWidth: 6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -93.0744,
    y: 0,
    width: 253.426,
    height: 253.426,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7.57345,
    dy: 7.57345
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1",
    x: 635.978,
    y: 872.759,
    width: 151.361,
    height: 174.143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_0_1",
    x: 844.134,
    y: 499.509,
    width: 99.8756,
    height: 109.303,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_0_1",
    x: -23.0005,
    y: 817.963,
    width: 194.005,
    height: 132.73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_0_1",
    x: 691,
    y: 59.9629,
    width: 194.005,
    height: 132.73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 159,
    fill: "white",
    transform: "translate(573 948.493) rotate(-41.888)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlayDeskLeft1);
export default __webpack_public_path__ + "static/media/overlay-desk-left-1.dbf2c2fd8d467cf00f3f7b5f6f4650b7.svg";
export { ForwardRef as ReactComponent };